import { ReactNode } from 'react';
import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconPicture from '@/icons/Picture.svg';

export const ArticleMediumAddedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_medium_added'>;
  displayArticleName: boolean;
}) => {
  const creatorName = activity.creator?.name;

  let articleMediaAddedMessage: ReactNode | undefined;

  if (activity.data.type === 'article-photo' || activity.data.type === 'defect-photo') {
    articleMediaAddedMessage = (
      <Trans id="activities.article_medium_added.message_defect_photo">
        <strong>{creatorName}</strong> added a photo to the item{' '}
        <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
      </Trans>
    );
  } else if (activity.data.type === 'proof-of-purchase') {
    articleMediaAddedMessage = (
      <Trans id="activities.article_medium_added.message_proof_of_purchase">
        <strong>{creatorName}</strong> added a proof of purchase to the item{' '}
        <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
      </Trans>
    );
  } else if (activity.data.type === 'proof-of-authenticity') {
    articleMediaAddedMessage = (
      <Trans id="activities.article_medium_added.message_proof_of_authenticity">
        <strong>{creatorName}</strong> added a proof of authenticity to the item{' '}
        <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
      </Trans>
    );
  }

  if (!articleMediaAddedMessage) return null;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      icon={<IconPicture />}
      message={<BaseActivityText>{articleMediaAddedMessage}</BaseActivityText>}
    />
  );
};
